import { Flex } from 'portal-commons';
import { FC } from 'react';

const Section: FC = ({ children }) => (
  <Flex sx={{ flexDirection: 'column', gap: 'm' }}>{children}</Flex>
);

export default Section;
